<template>
  <div class="prestore-card">
    <div class="main">
      <van-cell title="充值校区" required is-link @click="chooseCampus">
        <template>
          <div v-if="params.rechargeCampusId">
            <div class="vu van-ellipsis">{{ rechargeCampus.name }}</div>
          </div>
          <div v-else>请选择</div>
        </template>
      </van-cell>
      <van-field
        class="vf-phone"
        v-model="params.storedCardPhone"
        label="储值手机号"
        required
        type="tel"
        maxlength="11"
        :formatter="v => v.replace(/[^0-9]/g, '')"
        input-align="right"
        placeholder="请输入"
        ref="copyInput"
        right-icon="search"
        @click-right-icon="checkStoredPhone"
        />
      <div class="related-box" v-show="relatedList.length > 0">
        <div class="related-tips van-hairline--bottom">
          查找到{{ relatedTotalCount }}个持卡人手机号，可点击进行快捷选择
        </div>
        <div
          class="related-line van-hairline--bottom"
          v-for="item in relatedList"
          :key="item.id"
          @click="selectRelatedPhone(item)"
        >
          <span v-html="handlerSearch(item.storedCardPhone)"></span>（{{ item.storedCardName }}）
        </div>
      </div>

      <div class="wrap">
        <div class="til">收费储值卡</div>
        <template>
          <div
            class="item-list"
            :key="index"
            v-for="(item, index) in params.rechargeStoredCardItemRos"
          >
            <van-cell class="itil" :border="false" style="background: rgba(var(--g2-rgb), 0.3)" @click="goDetail(item)">
              <template #title>
                <span class="is-title van-multi-ellipsis--l2">{{ item.storedCardAccountName }}</span>
                <span class="is-tag" v-if="!item.cardNo">新卡</span>
                <span class="is-tag expire" v-if="item.status == 2">过期</span>
                <van-icon class="icon arrow" name="arrow" v-if="item.cardNo"/>
              </template>
              <template #right-icon>
                <div class="flex-center">
                  <div class="money" v-if="item.cardNo">余额￥{{ item.allTotalMoney | formatNumber }}</div>
                  <div class="del" @click.stop="delCard(index)">
                    <van-icon name="delete-o" color="var(--g6)" />
                  </div>
                </div>
              </template>
            </van-cell>
            <van-cell title="收费类型" required is-link @click="selectSfFlag(item)">
              <template>
                <div v-if="item.orderFlagId" class="vu">
                  {{ item.orderFlagName }}
                </div>
                <div v-else>请选择</div>
              </template>
            </van-cell>
            <van-field label="充值金额" required>
              <template #input>
                <div class="vu czje flex-column">
                  <van-field
                    class="czje-ipt"
                    v-model.number="item.principalTotalMoney"
                    type="number"
                    placeholder="请输入"
                    style="padding: 0"
                    input-align="right"
                    center
                    :formatter="priceInputFormatter"
                    @blur="verifyLowMoney(item)"
                  >
                  </van-field>
                  <div class="vutip" v-if="item.giveTotalMoney">
                    <span>赠送金额{{ item.giveTotalMoney | formatNumber }}</span>
                  </div>
                </div>
              </template>
            </van-field>
            <van-field
              v-model="item.storedCardName"
              required
              input-align="right"
              label="持卡人姓名"
              :formatter="v => v.trimLeft()"
              placeholder="请输入"
            />
            <van-cell title="绑定学员" is-link @click="selectBindStudent(item)" class="cus-cell">
              <template>
                <template v-if="item.bindStudentsList && item.bindStudentsList.length > 0">
                  <div class="vu van-ellipsis">
                    {{ item.bindStudentsList.map(v => v.name).join('、') }}
                  </div>
                </template>
                <div v-else>请选择</div>
              </template>
            </van-cell>
            <div class="phone-student-box" v-if="phoneStudentList.length>0">
              <div class="phone-student-title">此持卡人手机号关联了以下学员，可点击进行快捷选择</div>
              <div class="phone-student-wrap">
                <div class="phone-student-names" v-for="it in phoneStudentList" :key="it.id">
                <div class="names" :class="{'active': item.bindStudents.indexOf(it.id) > -1}" @click="selectStudent(it,item)">{{ it.studentName }}</div></div>
              </div>
            </div>
            <!-- 业绩归属 -->
            <belonger-input
              v-model="item.achievementBelongerList"
              @error="item.belongerErrMsg = $event"
              errmsg="每个项目的业绩比例之和必须等于100%"
            ></belonger-input>
          </div>
        </template>
        <!-- 选择项目 -->
        <div class="choose-btn" @click="chooseCard">
          <van-icon
            class-prefix="vxs-icon"
            name="system_add"
            size="16"
            style="margin-right: calc(var(--gap) * 8)"
          />
          购买新卡
        </div>
      </div>

      <!-- 整单其它信息 -->
      <template>
        <div class="separate"></div>
        <van-field
          readonly
          :right-icon="'arrow'"
          v-model="params.orderNotes"
          input-align="right"
          placeholder="请输入"
          @click.stop="updateNotes('orderNotes')"
        >
          <template #label>
            <div @click.stop="">
              <van-popover
                v-model="pop1"
                class="popover-wrap"
                theme="dark"
                trigger="click"
                placement="top-start"
                :offset="[-8, 4]"
              >
                <div style="width: 85vw">
                  不需要家长知悉的备注信息，本机构老师可在订单详情中查看，家长端订单详情不展示
                </div>
                <template #reference>
                  备注
                  <van-icon name="question-o" class="tips-icon" />
                </template>
              </van-popover>
            </div>
          </template>
        </van-field>
        <van-field
          readonly
          :right-icon="'arrow'"
          v-model="params.buyerNotes"
          input-align="right"
          placeholder="请输入"
          @click.stop="updateNotes('buyerNotes')"
        >
          <template #label>
            <div @click.stop="">
              <van-popover
                v-model="pop2"
                class="popover-wrap"
                theme="dark"
                trigger="click"
                placement="top-start"
                :offset="[-8, 4]"
              >
                <div style="width: 85vw">
                  需要家长知悉的备注信息，家长和本机构老师均可在订单详情中查看
                </div>
                <template #reference>
                  对外备注
                  <van-icon name="question-o" class="tips-icon" />
                </template>
              </van-popover>
            </div>
          </template>
        </van-field>
        <div class="separate"></div>
        <van-cell title="附件图片" is-link @click="uploadImg">
          <template #default>
            <span v-if="!params.attach.list.length" style="color: var(--c1)">上传图片</span>
            <span v-else>已上传{{ params.attach.list.length }}张图片</span>
          </template>
        </van-cell>
      </template>

      <div
        style="color: var(--c1); text-align: right; margin: 8px 16px"
        @click="
          $router.push({
            name: 'help-page',
            params: {
              src: 'https://bangzhu.xiaogj.com/yxhelp-list/detail-139.html',
            },
          })
        "
      >
        什么是储值卡充值？
      </div>
    </div>
    <div class="footer">
      <div class="l">
        <div class="bt">
          <span style="margin-right: calc(var(--gap) * 4)">订单金额:</span>
          <span style="color: var(--c3)">￥</span>
          <span style="color: var(--c3); font-size: var(--fs-ex1)">{{
            params.totalPrincipalTotalMoney | formatNumber
          }}</span>
        </div>
        <div class="bb">共赠送:￥{{ params.totalGiveTotalMoney | formatNumber }}</div>
      </div>

      <van-button
        square
        round
        type="primary"
        @click="submitOrder"
        data-test="sf-card-btn-submitOrder"
      >
        提交订单
      </van-button>
    </div>
  </div>
</template>

<script>
import belongerInput from '@teacher/components/belonger-input.vue';

export default {
  props: {
    phone: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rechargeCampus: app.teacher.campus,
      params: {
        // 充值校区ID	
        rechargeCampusId: app.teacher.campusId,
        // 持卡人手机
        storedCardPhone: this.$route.query.phone || '',
        orderNotes: '',
        buyerNotes: '',
        // 选中的购买项目
        rechargeStoredCardItemRos: [],
        // 凭证图片
        attach: {
          list: [],
        },
        // 总充值赠送金额
        totalGiveTotalMoney: 0,
        // 总充值本金金额
        totalPrincipalTotalMoney: 0,
      },
      pop1: false,
      pop2: false,
      relatedList: [],
      relatedTotalCount: 0,
      phoneStudentList: [],
      // preStoredPhone: '',
      preStoredCardItems: [], // 手机号码绑定的储值卡：用来处理删除已绑定的卡之后，又选择已有的储值卡的回显问题
    };
  },
  inject: ['openImage'],
  methods: {
    // 限制价格输入，从根本上避免用户输入不合法数据
    priceInputFormatter(newVal, regx = /^(([1-9]{1}\d{0,5})|(0{1}))(\.\d{0,2})?$/) {
      if (regx.test(newVal)) {
        return newVal;
      } else {
        return newVal.split('').slice(0, -1).join('');
      }
    },
    // 选择校区
    async chooseCampus() {
      let res = await app.x3.side.xsCampus({
        id: this.params.rechargeCampusId,
        config: {
          must: true,
        },
      });

      this.params.rechargeCampusId = res.id;
      this.rechargeCampus = res;
    },
    // 验证持卡人手机号
    checkStoredPhone() {
      this.$refs.copyInput.blur();
      this.params.storedCardPhone = this.params.storedCardPhone.trim();
      let { storedCardPhone } = this.params;
      this.relatedList = [];
      this.relatedTotalCount = 0;

      if (!/^\d{11}$/.test(this.params.storedCardPhone)) {
        if (storedCardPhone.length < 4) {
          this.$toast('请至少输入4位手机号码');
          return;
        } else {
          this.$api.getCardholderInfos({
            storedCardPhone: storedCardPhone,
            page: {
              pageSize: 4,
              pageNum: 1,
            },
          }).then(res => {
            this.relatedList = res.data || [];
            this.relatedTotalCount = res.page ? res.page.totalCount : 0;
          });
        }
      } else {
        this.getAccountAndStudentsByPhone();
      }
    },
    // 快捷选择手机号
    selectRelatedPhone(item) {
      this.params.storedCardPhone = item.storedCardPhone;
      this.relatedList = [];
      this.relatedTotalCount = 0;
      this.getAccountAndStudentsByPhone();
    },
    async getAccountAndStudentsByPhone() {
      // if(this.preStoredPhone == this.params.storedCardPhone.trim()) {
      //   return;
      // }
      this.params.rechargeStoredCardItemRos = [];
      this.preStoredCardItems = [];
      // this.preStoredPhone = this.params.storedCardPhone.trim();
      // 根据机构手机号查询机构下的储值卡信息
      // 根据家长手机号查询学生信息
      let res = await Promise.all([this.$api.getStoredCardAccounts({
        storedCardPhone: this.params.storedCardPhone.trim(),
        storedCardNo: '',
        storedCardAccountId: '',
      }), this.$api.getStudentByPhone({
        parentPhone: this.params.storedCardPhone.trim(),
      })]);
      if (res[0].code == 200 && res[0].data.length) {
        res[0].data.forEach(itm => {
          const obj = {
            achievementBelongerList: [],
            belongerErrMsg: '',
            bindStudents: [],
            bindStudentsList: [],
            giveTotalMoney: '',
            orderFlagId: '',
            orderFlagName: '',
            principalTotalMoney: '',
            storedCardAccountId: itm.id,
            storedCardAccountName: itm.storedCardAccountName,
            storedCardActivityId: itm.storedCardActivityId,
            storedCardActivityName: itm.storedCardActivityName,
            storedCardName: itm.storedCardName,
            allTotalMoney: itm.allTotalMoney,
            fillLowRechargeMoney: true,

            cardNo: itm.cardNo,
            principalTotalMoneyPre: itm.principalTotalMoney,
            giveTotalMoneyPre: itm.giveTotalMoney,
          };

          this.preStoredCardItems.push(obj);
          this.params.rechargeStoredCardItemRos.push(obj);
          this.getStoredCStudent(obj);
        });
      }
      if (res[1].code == 200) {
        this.phoneStudentList = res[1].data.map(v=> {
          return {
            ...v,
            name: v.studentName
          }
        });
      }
    },
    // 重复检查
    checkRepeat(obj) {
      let msg = '';
      for (let item of this.params.rechargeStoredCardItemRos) {
        if (obj.id == item.storedCardActivityId) {
          msg = '请勿重复添加同一储值卡活动。';
          break;
        }
      }
      return msg;
    },
    // 删除项目
    delCard(index) {
      this.params.rechargeStoredCardItemRos.splice(index, 1);
    },
    // 选择收费类型
    async selectSfFlag(item) {
      let res = await app.x3.side.xsSfType({
        id: item.orderFlagId,
      });
      item.orderFlagId = res? res.id : '';
      item.orderFlagName = res? res.name : '';
    },
    // 选择学员
    async selectBindStudent(item) {
      let ret = await app.x3.side.xsStudent({
        ids: item.bindStudents,
        list: item.bindStudentsList,
        params: {
          campusIds: [this.params.rechargeCampusId],
          campusList: [this.rechargeCampus],
        },
      });

      item.bindStudents = ret.ids;
      item.bindStudentsList = ret.list;
    },
    // 购买新卡
    async chooseCard() {
      if (!this.params.storedCardPhone) {
        return vant.Toast('请输入储值手机号');
      } else if (!/^\d{11}$/.test(this.params.storedCardPhone)) {
        return vant.Toast('储值手机号格式不正确');
      }
      let ids = this.preStoredCardItems.map(v=> v.storedCardActivityId);
      let res = await app.x3.side.xsStoredCard();
      res.list.forEach(itm => {
        if (this.checkRepeat(itm)) {
          vant.Toast.fail('请勿重复添加同一储值卡活动。');
        } else if(ids.indexOf(itm.id) > -1) {
          let idx = ids.indexOf(itm.id);
          this.params.rechargeStoredCardItemRos.push(this.preStoredCardItems[idx]);
        } else {
          let obj = {
            achievementBelongerList: [],
            belongerErrMsg: '',
            bindStudents: [],
            bindStudentsList: [],
            giveTotalMoney: '',
            orderFlagId: '',
            orderFlagName: '',
            principalTotalMoney: '',
            storedCardAccountId: '',
            storedCardAccountName: itm.activityName,
            storedCardActivityId: itm.id,
            storedCardActivityName: itm.activityName,
            storedCardName: '',
            fillLowRechargeMoney: true,
          };

          this.params.rechargeStoredCardItemRos.push(obj);
        }
      });
    },
    // 根据储值卡查询关联学生
    async getStoredCStudent(item) {
      const res = await this.$api.getStoredCardStudent({
        storedCardId: item.storedCardAccountId,
      });
      item.bindStudents = res.data.map(v=> v.studentId);
      item.bindStudentsList = res.data.map(v=> {
        return {
          id: v.studentId,
          name: v.studentName
        }
      });
    },
    selectStudent(it, item) {
      let i = item.bindStudents.indexOf(it.id);
      if (i === -1) {
        item.bindStudents.push(it.id);
        item.bindStudentsList.push(it);
      } else {
        item.bindStudents.splice(i, 1);
        item.bindStudentsList.splice(i, 1);
      }
    },
    async updateNotes(keyName) {
      let res = await app.x3.side.xsApprovalOpinion({
        config: {
          pageTitle: keyName == 'orderNotes' ? '编辑备注' : '编辑对外备注',
        },
        field: {
          prop: keyName,
          defaultValue: this.params[keyName],
          attrs: {
            placeholder:
              keyName == 'orderNotes'
                ? '请输入备注，仅本机构老师可见'
                : '请输入对外备注，学员、家长和本机构老师均可见',
            showWordLimit: true,
            maxlength: 500,
            rows: 4,
            inputAlign: 'left',
            clearable: true,
            autosize: true,
          },
        },
      });
      this.params[keyName] = res[keyName];
    },
    async uploadImg() {
      const obj = await this.openImage(this.params.attach);
      this.params.attach = obj;
    },
    handlerSearch(text) { // 处理高亮
      let hightlightText = '';
      hightlightText = text.replace(new RegExp(`(${this.params.storedCardPhone})`, 'g'), `<span style="color: var(--c1);">$1</span>`);
      return hightlightText;
    },
    goDetail(item) { // 查看卡详情
      if (item.cardNo) {
        this.$router.push(`/storedCardDetail/${item.storedCardAccountId}`);
      }
    },
    async calcMoney() {
      return new Promise(async _resolve => {
        // let err = this.calcVerify();
        // if (err) {
        //   return;
        // } else {
          // let amountList = this.params.rechargeStoredCardItemRos.filter(item=> (item.principalTotalMoney !== '' && item.principalTotalMoney !== null && item.principalTotalMoney !== undefined));
          // if (amountList.length == 0) {
          //   return;
          // }
          let calcParams = {
            amountItems: [],
          };
          this.params.rechargeStoredCardItemRos.forEach(itm => {
            if (itm.principalTotalMoney !== '' && itm.principalTotalMoney !== null && itm.principalTotalMoney !== undefined) {
              calcParams.amountItems.push({
                amount: itm.principalTotalMoney,
                giveAmount: itm.giveTotalMoney,
                storedCardActivityId: itm.storedCardActivityId,
              });
            }
          });
  
          if (this._oldCalcParams && this._oldCalcParams === JSON.stringify(calcParams)) {
            _resolve(this._cp);
            return false;
          }
  
          this._oldCalcParams = JSON.stringify(calcParams);
  
          if (this._cp) {
            try {
              this._cp.cancel();
            } catch (err) {
              console.log('取消上次计算了');
            }
          }
  
          this._cp = this.$api.calculateAmount(calcParams);
          
          try {
            let res = await this._cp;
            this.params.totalPrincipalTotalMoney = res.data.principalTotalMoney;
            this.params.totalGiveTotalMoney = res.data.giveTotalMoney;
            this.params.rechargeStoredCardItemRos.forEach(itm => {
              itm.giveTotalMoney = '';
              res.data.amountItems.forEach(item => {
                if (itm.storedCardActivityId == item.storedCardActivityId) {
                  itm.giveTotalMoney = item.giveAmount;
                  itm.fillLowRechargeMoney = item.fillLowRechargeMoney; // 是否满足了最低起充金额，true满足false不满足
                  itm.lowRechargeMoney = item.lowRechargeMoney; // 最低起充金额
                }
              })
            });
  
            _resolve('计算完成');
          } catch (err) {
            _resolve(this._cp);
            console.log('err',err);
          }
        // }
      });
    },
    // calcVerify() {
    //   let msg = '';
    //   this.params.rechargeStoredCardItemRos.forEach(item => {
    //     if (
    //       !item.storedCardActivityId ||
    //       item.principalTotalMoney === '' ||
    //       item.principalTotalMoney === null ||
    //       item.principalTotalMoney === undefined
    //     ) {
    //       msg = '请输入充值金额';
    //     }
    //   });
    //   return msg;
    // },
    verify() {
      let msg = '';

      if (!this.params.rechargeCampusId) {
        msg = '请选择充值校区';
      } else if (!this.params.storedCardPhone) {
        msg = '请输入储值手机号';
      } else if(!/^\d{11}$/.test(this.params.storedCardPhone)){
        msg = '储值手机号格式不正确';
      } else if (this.params.rechargeStoredCardItemRos.length == 0) {
        msg = '请选择收费储值卡';
      } else if (this.params.rechargeStoredCardItemRos.length > 0) {
        msg = this.allItemCerify();
      } 
      return msg;
    },
    // 各项目必填字段校验
    allItemCerify() {
      let msg = '';
      this.params.rechargeStoredCardItemRos.forEach(item => {
        if (!item.orderFlagId) {
          msg = '请选择收费类型';
          return false;
        } else if (!item.principalTotalMoney) {
          msg = '请输入充值金额';
          return false;
        } else if(!item.fillLowRechargeMoney) {
          msg = `${item.storedCardAccountName}的最低起充金额为${item.lowRechargeMoney}，请重新输入`;
          return false;
        } else if (!item.storedCardName) {
          msg = '请输入持卡人姓名';
          return false;
        }
        if (item.belongerErrMsg) {
          msg = item.belongerErrMsg;
        }
      });
      return msg;
    },
    async submitOrder() {
      let err = this.verify();
      if (err) {
        vant.Toast(err);
      } else {
        try {
          await this.calcMoney();
          let smParams = app.tool.clone(this.params);
  
          this.showLoading();
          let res = await this.$api.storedCardRecharge(smParams);
          this.$toast.clear();
          if (res.code == 200) {
            let orderId = res.data.id;
            if (!orderId) {
              this.$toast('未知异常，请稍后重试');
              return false;
            }
            if (smParams.totalPrincipalTotalMoney == 0) {
              this.$router.push(`/pay?orderId=${orderId}&step=2&hideContract=1`);
            } else {
              this.$router.push(`/sf2/${orderId}?routerName=prestore`);
            }
          } else if (res.code === 740000001) {
            let oinfo = JSON.parse(res.msg);
            try {
              await vant.Dialog.confirm({
                title: '提示',
                message: '当前手机号存在【待付款】订单，请前往完成支付。',
                confirmButtonText: '查看',
              });
              this.$router.push(
                `/orderDetail/${oinfo.orderId}/${oinfo.orderType}/${oinfo.sourceType}`
              );
            } catch (error) {}
          }
        } catch (error) {
          console.log('error',error)
          if (error) {
            vant.Toast(error.msg);
          }
        }
      }
    },
    verifyLowMoney(item) {
      if (!item.fillLowRechargeMoney) {
        this.$toast(`${item.storedCardAccountName}的最低起充金额为${item.lowRechargeMoney}，请重新输入`);
      }
    }
  },
  watch: {
    'params.rechargeStoredCardItemRos': {
      deep: true,
      handler: function (newValue, oldValue) {
        this.calcMoney();
      },
    },
  },
  created() {
    if (/^\d{11}$/.test(this.phone)) {
      this.getAccountAndStudentsByPhone();
    }
  },
  beforeDestroy() {
    this.$toast.clear();
  },
  components: {
    belongerInput,
  },
};
</script>

<style lang="scss" scoped>
.prestore-card {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .main {
    flex: 1;
    overflow-y: auto;
    .vf-phone {
      &::after {
        left: 0;
        right: 0;
      }
    }
    .related-box {
      padding: 0 calc(var(--gap) * 16);
      background-color: var(--white);
      .related-tips {
        padding: calc(var(--gap) * 8) 0;
        color: var(--g6);
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
      }
      .related-line {
        color: var(--black);
        padding: calc(var(--gap) * 16) 0;
      }
    }
    .phone-student-box {
      margin: 0 calc(var(--gap) * 16);
      // padding: 0 calc(var(--gap) * 8);
      background-color: var(--g2);
      border-radius: var(--radius-base);
      .phone-student-title {
        padding: calc(var(--gap) * 8) calc(var(--gap) * 8) 0 calc(var(--gap) * 8); 
        font-size:var(--fs-sm);
        line-height:var(--lh-sm);
        color: var(--g6);
      }
      .phone-student-wrap {
        padding: 0 calc(var(--gap) * 4);
        display: flex;
        flex-wrap: wrap;
        .phone-student-names {
          margin: calc(var(--gap) * 4);
          .names {
            padding: calc(var(--gap) * 3) calc(var(--gap) * 8);
            font-size:var(--fs-md);
            line-height:var(--lh-md);
            border-radius: var(--radius-base);
            color: var(--g8);
            border: 1px solid var(--g3);
            background-color: var(--white);
            &.active {
              color: var(--c1);
              border: 1px solid var(--c1);
            }
          }
        }
      }
    }

    .wrap {
      padding: 0 calc(var(--gap) * 16) 0;
      background: var(--g1);
      .til {
        padding: calc(var(--gap) * 8) 0;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
      }
      .choose-btn {
        margin: calc(var(--gap) * 12) 0;
        height: calc(var(--w) * 70);
        display: flex;
        justify-content: center;
        align-items: center;
        background: var(--white);
        border-radius: var(--radius-sm);
        color: var(--c1);
        font-weight: bold;
        font-size: var(--fs-md);
        line-height: var(--lh-md);
      }
      .item-list {
        background: var(--white);
        border-radius: var(--radius-sm);
        overflow: hidden;
        margin: calc(var(--gap) * 12) 0;
        .itil {
          font-weight: bold;
          .van-cell__title {
            color: var(--g8);
            display: flex;
            align-items: center;
            overflow: hidden;
            .is-title {
              max-width: calc(100% - 45px);
            }
            .is-tag {
              font-weight: normal;
              text-align: center;
              width: calc(var(--gap) * 32);
              padding: calc(var(--gap) * 1) 0;
              font-size: var(--fs-sm);
              line-height: var(--lh-sm);
              color: var(--white);
              background-color: var(--c1);
              border-radius: calc(var(--radius-base) * 0.5);
              margin-left: calc(var(--gap) * 4);
              &.expire {
                color: var(--white);
                background-color: var(--g6);
              }
            }
          }
          .money {
            color: var(--c3);
            font-weight: normal;
          }
          .del {
            display: flex;
            align-items: center;
            font-size: 24px;
            padding-left: 8px;
          }
        }
      }
    }
    .van-field {
      .czje {
        color: vat(--g8);
        justify-content: right;
        flex: 1;
        align-items: flex-end;
        .czje-ipt {
          &::after {
            border: none;
          }
        }
      }
      .vutip {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
      }
    }
    .van-cell {
      .van-cell__value {
        color: var(--g5);
      }
      .vu {
        color: var(--g8);
      }
    }
  }
  .footer {
    background: var(--white);
    padding: calc(var(--gap) * 5) calc(var(--gap) * 16);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .l {
      .bt {
        font-size: var(--fs-md);
        line-height: var(--lh-md);
        color: var(--g6);
        display: flex;
        align-items: center;
      }
      .bb {
        font-size: var(--fs-sm);
        line-height: var(--lh-sm);
        color: var(--g6);
      }
    }
    .van-button {
      height: var(--cl-xs);
    }
  }
}
</style>